import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const consultAuthSessionResponseSchema = jsonObject
export const consultAuthLogoutResponseSchema = jsonObject
export type ConsultAuthSessionResponse = z.infer<typeof consultAuthSessionResponseSchema>
export type ConsultAuthLogoutResponse = z.infer<typeof consultAuthLogoutResponseSchema>
